

import React, { memo, useMemo, useCallback } from 'react';
import cx from 'classnames';
import SVG from 'react-inlinesvg';



import {
  PAGE_HEADER,
  ACTION_CONTENT,
  ACTION_BTN_MOBILE } from
'../styles/pageHeader';
import { NUMERIC_MEDIA_SIZES } from '../../../common/styles/vars';
import TitleBox from '../../TitleBox';
import Button from '../../Button';
import Text from '../../Text';
import Icon from '../../Icon';
import LinkComponent from '../../Link';
import ActionPopup from '../../ActionPopup';
import {
  LOGIN_LINK,
  CONTACT_US_LINK,
  VIDEO_PRODUCTION_LINK } from
'../constants/links';
import shootstaFullLogo from '../../../assets/images/shootstalogo-with-subtitle.svg';

import '../styles/_page-header.scss';

const SHOOTSTA_LOGO = 'shootstacolour';






































function PageHeader({
  title,
  breadCrumbs,
  titlePlaceHolder,
  titlePrefixContent,
  subtitle,
  subtitleLink,
  actionBtnText,
  actionBtnMobileIcon,
  actionBtnOnClick,
  actionBtnIsAlwaysIcon,
  actionBtnBusy,
  actionBtnDisabled,
  secondaryContent,
  editableTitle,
  onBlurTitle,
  onChangeTitle,
  titleIconColor,
  alwaysShowSubtitle,
  actionPopupOptions,
  darkMode,
  size,
  titleSuffixIcon,
  history,
  loading,
  isAnonymous,
  titleSuffix,
  actionButtonProps,
  rightAddOns
}) {
  const isMobile = useMemo(
    () => size.width && size.width < NUMERIC_MEDIA_SIZES.small,
    [size.width]
  );

  const onOpenLink = useCallback(
    (link) => () => {
      window.open(link, '_blank');
    },
    []
  );

  const actionButtonConsolidatedProps = useMemo(() => ({
    ...actionButtonProps,
    key: 'page-header-action-mob',
    className: cx(
      { [ACTION_BTN_MOBILE]: isMobile || actionBtnIsAlwaysIcon },
      'page-header__action-button',
      actionButtonProps?.className
    ),
    busy: actionBtnBusy || actionButtonProps?.busy,
    disabled: Boolean(actionBtnDisabled || actionButtonProps?.disabled),
    prefix:
    isMobile || actionBtnIsAlwaysIcon ?
    actionBtnMobileIcon :
    actionButtonProps?.prefix || '',
    onClick: actionBtnOnClick || actionButtonProps?.onClick
  }), [
  actionButtonProps,
  isMobile,
  actionBtnIsAlwaysIcon,
  actionBtnBusy,
  actionBtnDisabled,
  actionBtnMobileIcon,
  actionBtnOnClick]
  );


  const actionButtonChildren = useMemo(
    () => actionBtnText || actionButtonProps?.children,
    [actionBtnText, actionButtonProps?.children]
  );

  return (
    <div className={cx('column', 'page-header', PAGE_HEADER({ darkMode }))}>
      {isAnonymous ?
      <div className="page-header__anonymous_icon">
          <LinkComponent
          className="page-header__title"
          onClick={onOpenLink(VIDEO_PRODUCTION_LINK)}>

            {isMobile ?
          <Icon size={40} name={SHOOTSTA_LOGO} /> :

          <SVG
            cacheRequests
            width={200}
            src={shootstaFullLogo}
            uniquifyIDs
            title="shootsta" />}


          </LinkComponent>
        </div> :

      <TitleBox
        title={title}
        titlePrefixContent={titlePrefixContent}
        breadCrumbs={breadCrumbs}
        titlePlaceHolder={titlePlaceHolder}
        subtitle={subtitle}
        subtitleLink={subtitleLink}
        editableTitle={editableTitle}
        titleIconColor={titleIconColor}
        alwaysShowSubtitle={alwaysShowSubtitle}
        darkMode={darkMode}
        titleSuffixIcon={titleSuffixIcon}
        history={history}
        loading={loading}
        titleSuffix={titleSuffix}
        onBlurTitle={onBlurTitle}
        onChangeTitle={onChangeTitle} />}



      {!loading &&
      <div className={cx(ACTION_CONTENT, 'page-header__action-content')}>
          {isAnonymous &&
        <>
              {!isMobile &&
          <>
                  <div className="page-header__action-content__anonymous-text">
                    <Text>
                      Take Your Video Production to the Next Level!&nbsp;
                      <LinkComponent
                  onClick={onOpenLink(VIDEO_PRODUCTION_LINK)}>

                        Learn More
                      </LinkComponent>
                    </Text>
                  </div>
                  <LinkComponent
              className="page-header__action-login"
              onClick={onOpenLink(LOGIN_LINK)}>

                    <Button type="TERTIARY">Login</Button>
                  </LinkComponent>
                </>}


              <LinkComponent
            className="page-header__action-contact-us"
            onClick={onOpenLink(CONTACT_US_LINK)}>

                <Button>Get in touch</Button>
              </LinkComponent>
            </>}

          {secondaryContent}
          {actionButtonChildren &&
        <Button {...actionButtonConsolidatedProps}>
              {isMobile || actionBtnIsAlwaysIcon ? null : actionButtonChildren}
            </Button>}


          {/* $FlowFixMe */}
          {actionPopupOptions ? <ActionPopup options={actionPopupOptions} /> : null}
          {rightAddOns || null}
        </div>}

    </div>);

}

PageHeader.displayName = 'PageHeader';
PageHeader.defaultProps = {
  actionBtnMobileIcon: 'addfat',
  actionBtnDisabled: false,
  secondaryContent: null,
  editableTitle: false
};

export default memo(PageHeader);